var o = /* @__PURE__ */ ((i) => (i.NoContiguousAvailability = "no-continuous-availability", i))(o || {});
export {
  o as DefaultSelectionError
};
